import React from "react";

import kerbside from "images/conditionIcons/kerbside.png";
import groundLevel from "images/conditionIcons/ground-level.png";
import weightLimit from "images/conditionIcons/weight-limit.png";
import vehicleRequirements from "images/conditionIcons/vehicle-requirements.png";
import surfaceRequirements from "images/conditionIcons/surface-requirements.png";
import noGravelSurfaces from "images/conditionIcons/no-gravel-surfaces.png";
import noSteepSlopes from "images/conditionIcons/no-steep-slopes.png";
import driverAccessPolicy from "images/conditionIcons/driver-access-policy.png";
import minimumVehicleSize from "images/conditionIcons/minimum-vehicle-size.png";


const PalletDelivers: React.FC = () => {
  return (
    <div className="relative py-16 bg-gradient-to-br from-primary-50 via-white to-primary-100 dark:from-slate-900 dark:via-slate-800 dark:to-slate-900">
        <div className="container">
        <div className="flex flex-col items-center justify-center">
            <h2 className="text-4xl font-extrabold text-primary-700 dark:text-primary-700 mb-2 animate-fade-in-down">
            Before Booking, there are few things you should know
            </h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8 w-full max-w-6xl my-8">
            {/* Card 1 */}
            <div className="group bg-white dark:bg-slate-800 rounded-2xl shadow-xl p-8 flex flex-col items-center transition-transform duration-300 hover:-translate-y-2 hover:shadow-2xl animate-fade-in-up">
                <div className="border-2 border-primary-700 rounded-full p-4 mb-4 animate-bounce-slow">
                <img src={kerbside} alt="Kerbside Delivery" className="w-16 h-16" />
                </div>
                <h3 className="text-lg font-semibold mb-2 text-primary-700 dark:text-primary-700">Kerbside Delivery</h3>
                <p className="text-gray-600 dark:text-gray-200 text-center">Pallets are delivered to a kerbside location only.</p>
            </div>
            {/* Card 2 */}
            <div className="group bg-white dark:bg-slate-800 rounded-2xl shadow-xl p-8 flex flex-col items-center transition-transform duration-300 hover:-translate-y-2 hover:shadow-2xl animate-fade-in-up delay-75">
                <div className="border-2 border-primary-700 rounded-full p-4 mb-4 animate-bounce-slow">
                <img src={groundLevel} alt="Ground Level Service" className="w-16 h-16" />
                </div>
                <h3 className="text-lg font-semibold mb-2 text-primary-700 dark:text-primary-700">Ground Level Only</h3>
                <p className="text-gray-600 dark:text-gray-200 text-center">Collections and deliveries are at ground level only.</p>
            </div>
            {/* Card 3 */}
            <div className="group bg-white dark:bg-slate-800 rounded-2xl shadow-xl p-8 flex flex-col items-center transition-transform duration-300 hover:-translate-y-2 hover:shadow-2xl animate-fade-in-up delay-100">
                <div className="border-2 border-primary-700 rounded-full p-4 mb-4 animate-bounce-slow">
                <img src={weightLimit} alt="Weight Limit" className="w-16 h-16" />
                </div>
                <h3 className="text-lg font-semibold mb-2 text-primary-700 dark:text-primary-700">Weight Limit</h3>
                <p className="text-gray-600 dark:text-gray-200 text-center">Maximum pallet weight: <span className="font-bold text-primary-600 dark:text-primary-200">1000 kg</span>.</p>
            </div>
            {/* Card 4 */}
            <div className="group bg-white dark:bg-slate-800 rounded-2xl shadow-xl p-8 flex flex-col items-center transition-transform duration-300 hover:-translate-y-2 hover:shadow-2xl animate-fade-in-up delay-150">
                <div className="border-2 border-primary-700 rounded-full p-4 mb-4 animate-bounce-slow">
                <img src={vehicleRequirements} alt="Vehicle Requirements" className="w-16 h-16" />
                </div>
                <h3 className="text-lg font-semibold mb-2 text-primary-700 dark:text-primary-700">Vehicle Requirements</h3>
                <p className="text-gray-600 dark:text-gray-200 text-center">Let us know if you need a small vehicle for collection or delivery.</p>
            </div>
            {/* Card 5 */}
            <div className="group bg-white dark:bg-slate-800 rounded-2xl shadow-xl p-8 flex flex-col items-center transition-transform duration-300 hover:-translate-y-2 hover:shadow-2xl animate-fade-in-up delay-200">
                <div className="border-2 border-primary-700 rounded-full p-4 mb-4 animate-bounce-slow">
                <img src={surfaceRequirements} alt="Surface Requirements" className="w-16 h-16" />
                </div>
                <h3 className="text-lg font-semibold mb-2 text-primary-700 dark:text-primary-700">Surface Requirements</h3>
                <p className="text-gray-600 dark:text-gray-200 text-center">Pump trucks need a hard, even surface to operate.</p>
            </div>
            {/* Card 6 */}
            <div className="group bg-white dark:bg-slate-800 rounded-2xl shadow-xl p-8 flex flex-col items-center transition-transform duration-300 hover:-translate-y-2 hover:shadow-2xl animate-fade-in-up delay-300">
                <div className="border-2 border-primary-700 rounded-full p-4 mb-4 animate-bounce-slow">
                <img src={noGravelSurfaces} alt="No Gravel Surfaces" className="w-16 h-16" />
                </div>
                <h3 className="text-lg font-semibold mb-2 text-primary-700 dark:text-primary-700">No Gravel Surfaces</h3>
                <p className="text-gray-600 dark:text-gray-200 text-center">We cannot operate pallet trucks on gravel surfaces.</p>
            </div>
            {/* Card 7 */}
            <div className="group bg-white dark:bg-slate-800 rounded-2xl shadow-xl p-8 flex flex-col items-center transition-transform duration-300 hover:-translate-y-2 hover:shadow-2xl animate-fade-in-up delay-500">
                <div className="border-2 border-primary-700 rounded-full p-4 mb-4 animate-bounce-slow">
                <img src={noSteepSlopes} alt="No Steep Slopes" className="w-16 h-16" />
                </div>
                <h3 className="text-lg font-semibold mb-2 text-primary-700 dark:text-primary-700">No Steep Slopes</h3>
                <p className="text-gray-600 dark:text-gray-200 text-center">No collections or deliveries on steep slopes.</p>
            </div>
            {/* Card 8 */}
            <div className="group bg-white dark:bg-slate-800 rounded-2xl shadow-xl p-8 flex flex-col items-center transition-transform duration-300 hover:-translate-y-2 hover:shadow-2xl animate-fade-in-up delay-700">
                <div className="border-2 border-primary-700 rounded-full p-4 mb-4 animate-bounce-slow">
                <img src={driverAccessPolicy} alt="Driver Access Policy" className="w-16 h-16" />
                </div>
                <h3 className="text-lg font-semibold mb-2 text-primary-700 dark:text-primary-700">Driver Access Policy</h3>
                <p className="text-gray-600 dark:text-gray-200 text-center">Drivers cannot enter your premises to collect or deliver.</p>
            </div>
            {/* Card 9 */}
            <div className="group bg-white dark:bg-slate-800 rounded-2xl shadow-xl p-8 flex flex-col items-center transition-transform duration-300 hover:-translate-y-2 hover:shadow-2xl animate-fade-in-up delay-1000">
                <div className="border-2 border-primary-700 rounded-full p-4 mb-4 animate-bounce-slow">
                <img src={minimumVehicleSize} alt="Minimum Vehicle Size" className="w-16 h-16" />
                </div>
                <h3 className="text-lg font-semibold mb-2 text-primary-700 dark:text-primary-700">Minimum Vehicle Size</h3>
                <p className="text-gray-600 dark:text-gray-200 text-center">Smallest vehicle we use is <span className="font-bold text-primary-600 dark:text-primary-200">7.5T</span>, subject to availability.</p>
            </div>
            </div>
        </div>
        </div>
        {/* Custom Animations */}
        <style>
        {`
            @keyframes fade-in-up {
            0% { opacity: 0; transform: translateY(40px);}
            100% { opacity: 1; transform: translateY(0);}
            }
            @keyframes fade-in-down {
            0% { opacity: 0; transform: translateY(-40px);}
            100% { opacity: 1; transform: translateY(0);}
            }
            @keyframes bounce-slow {
            0%, 100% { transform: translateY(0);}
            50% { transform: translateY(-8px);}
            }
            .animate-fade-in-up {
            animation: fade-in-up 0.8s cubic-bezier(.39,.575,.565,1) both;
            }
            .animate-fade-in-down {
            animation: fade-in-down 0.8s cubic-bezier(.39,.575,.565,1) both;
            }
            .animate-bounce-slow {
            animation: bounce-slow 2.2s infinite;
            }
            .delay-75 { animation-delay: 0.075s; }
            .delay-100 { animation-delay: 0.1s; }
            .delay-150 { animation-delay: 0.15s; }
            .delay-200 { animation-delay: 0.2s; }
            .delay-300 { animation-delay: 0.3s; }
            .delay-500 { animation-delay: 0.5s; }
            .delay-700 { animation-delay: 0.7s; }
            .delay-1000 { animation-delay: 1s; }
        `}
        </style>
    </div>

  );
};

export default PalletDelivers;
